console.warn('DEPRECATED: please replace import of `ng2-bootstrap/ng2-bootstrap` with `ng2-bootstrap`');
export * from './index';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
